import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AuthContextProvider from "./contexts/AuthContext";
import {BrowserRouter} from "react-router-dom";
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import 'react-notifications/lib/notifications.css';
import './styles/theme.css';
import AppErrorBoundary from "./components/AppErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <AppErrorBoundary>
          <AuthContextProvider>
              <BrowserRouter>
                  <App/>
              </BrowserRouter>
          </AuthContextProvider>
      </AppErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
